import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, withStyles, Typography } from '@material-ui/core'
import ReactSelect from 'components/theme/Select'
import {
  selectContactsForGroup,
  selectCampaignToRemoveContactFrom,
} from 'actions/tasks'
import { contactOptionsSelector } from 'selectors'
import { list } from 'actions/data'

export default connect(
  state => ({
    contactOptions: contactOptionsSelector(state),
    contactsSelectedForGroup: state.tasks.addOrEdit.contactsSelectedForGroup,
    automationTypeSelected: state.tasks.addOrEdit.automationTypeSelected,
    taskID: state.tasks.addOrEdit.taskID,
    campaigns: state.data?.campaign,
    campaignSelected: state.tasks.addOrEdit.campaignSelectedToRemoveContactFrom,
  }),
  dispatch =>
    bindActionCreators(
      { selectContactsForGroup, list, selectCampaignToRemoveContactFrom },
      dispatch,
    ),
)(
  withStyles(theme => ({
    paper: {
      [theme.breakpoints.down('sm')]: {
        padding: 20,
      },
    },
  }))(
    ({
      contactOptions,
      contactsSelectedForGroup,
      automationTypeSelected,
      selectContactsForGroup,
      taskID,
      classes,
      list,
      campaigns,
      campaignSelected,
      selectCampaignToRemoveContactFrom,
    }) => {
      const customStyles = {
        control: provided => ({
          ...provided,
          borderColor: 'rgba(0, 0, 0, 0.23)',
          borderRadius: '28px',
          padding: '9px 0',
        }),
        menu: provided => ({
          ...provided,
          zIndex: 2,
        }),
      }

      const campaign = campaigns?.[campaignSelected]
      const value = {
        value: campaign?.id,
        label: campaign?.name,
        key: `${campaign?.id}-Campaign`,
      }

      return (
        <div className={classes.paper}>
          <Grid container spacing={16}>
            {automationTypeSelected === 'stage' ? (
              <Grid item xs={12}>
                <Typography variant="h5" gutterBottom>
                  {`Select the campaign you want to remove contacts from`}
                </Typography>
                <ReactSelect
                  styles={customStyles}
                  value={value}
                  onChange={newValue =>
                    selectCampaignToRemoveContactFrom(newValue?.value)
                  }
                  closeMenuOnSelect
                  isMulti={false}
                  options={Object.values(campaigns || {}).map(el => ({
                    value: el.id,
                    label: el.name,
                    key: `${el.id}-Campaign`,
                  }))}
                  placeholder="Selected campaign"
                />
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Typography variant="h5" gutterBottom>
                  {`Select the contacts that you want removed from a campaign`}
                </Typography>
                <ReactSelect
                  styles={customStyles}
                  value={contactsSelectedForGroup}
                  onChange={newValue => selectContactsForGroup(newValue)}
                  closeMenuOnSelect={false}
                  isMulti
                  options={contactOptions}
                  placeholder="Selected contacts"
                />
                <div style={{ height: 20 }} />
                <Typography variant="h5" gutterBottom>
                  {`Select the campaign you want to remove contacts from`}
                </Typography>
                <ReactSelect
                  styles={customStyles}
                  value={value}
                  onChange={newValue =>
                    selectCampaignToRemoveContactFrom(newValue?.value)
                  }
                  closeMenuOnSelect
                  isMulti={false}
                  options={Object.values(campaigns || {}).map(el => ({
                    value: el.id,
                    label: el.name,
                    key: `${el.id}-Campaign`,
                  }))}
                  placeholder="Selected campaign"
                />
              </Grid>
            )}
          </Grid>
        </div>
      )
    },
  ),
)
